import { styled } from '@linaria/react'
import { AvatarImageContainerSC } from 'atoms/Avatar/Templates/AvatarImage.styled'
import { FIXED_INDENTS, MEDIA } from 'vars/index'

export const ChooseAvatarSC = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(${FIXED_INDENTS.INDENT_30});

  ${MEDIA.MIN_600} {
    gap: var(${FIXED_INDENTS.INDENT_40});
  }
`

export const ChooseAvatarAvatarsSC = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(${FIXED_INDENTS.INDENT_50});

  ${AvatarImageContainerSC} {
    width: 96px;
    height: 96px;
  }

  ${MEDIA.MIN_600} {
    gap: var(${FIXED_INDENTS.INDENT_80});
  }
`
